import styled from 'styled-components';

const Page = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
`;

export default Page;
